import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & {
  color?: string;
  size?: number;
};

const SvgTrashcanIcon = ({ color, size = 40, ...props }: Props) => {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="svg-wrapper"
      transform={`scale(${size / 40})`}
      style={{ WebkitTransform: `scale(${size / 40})` }}
      {...props}
    >
      <path
        d="M31.025 10.4H25.79V8.975a.52.52 0 0 0-.516-.517H14.708a.52.52 0 0 0-.517.517V10.4H8.958a.52.52 0 0 0-.517.517v3.066c0 .092.075.175.175.175h22.742a.176.176 0 0 0 .175-.175v-3.066a.52.52 0 0 0-.517-.517h.009ZM28.075 16.642h-16.15a.176.176 0 0 0-.176.175v14.208a.52.52 0 0 0 .517.517h15.467a.52.52 0 0 0 .517-.517V16.817a.176.176 0 0 0-.175-.175ZM21.14 27.433c0 .192-.15.342-.341.342h-1.592a.338.338 0 0 1-.342-.342V20.4c0-.192.15-.342.342-.342h1.591c.192 0 .342.15.342.342v7.033Z"
        fill={color || "#F7F6F5"}
      />
    </svg>
  );
};

export default SvgTrashcanIcon;
